import { useEffect, useState } from 'react';
import EventsList from 'src/components/templates/EventsList';
import EventSearch from 'src/services/EventSearch';
import Head from 'src/components/molecules/Head';
import { useRouter } from 'src/hooks/useRouter';
import { parsePageWithZeroIndex } from 'src/utils/pagination';
import EventListSeoTags from '../components/molecules/Head/EventListSeoTags';
import { usePluginConfig } from '../contexts/pluginContext';

const HomePage = () => {
  const [apiLoading, setApiLoading] = useState(true);
  const pluginConfig = usePluginConfig();
  const publisherSettings = pluginConfig.publisherSettings;
  const router = useRouter();

  const [rawEvents, setRawEvents] = useState([]);
  const [rawFeaturedEvents, setRawFeaturedEvents] = useState([]);
  const [rawEditorsPickEvents, setRawEditorsPickEvents] = useState([]);

  useEffect(() => {
    const prepareData = async () => {
      const searchClient = new EventSearch({ context: router, pluginConfig });
      const pageNumber = parsePageWithZeroIndex(router.query.evPage);

      const data = await searchClient.homePageEvents(pageNumber);

      setRawEvents(data.rawEvents);
      setRawFeaturedEvents(data.rawFeaturedEvents);
      setRawEditorsPickEvents(data.rawEditorsPickEvents);
      pluginConfig.setRawFacets(data.rawFacets);
    };

    prepareData().then(() => {
      setApiLoading(false);
    });
  }, []);

  return (
    <>
      <Head publisherSettings={publisherSettings} />
      <EventListSeoTags categorySlug={router.query.category} />
      <EventsList
        publisherSettings={publisherSettings}
        rawEvents={rawEvents}
        rawFeaturedEvents={rawFeaturedEvents}
        rawEditorsPickEvents={rawEditorsPickEvents}
        apiLoading={apiLoading}
        category={router.query.category}
      />
    </>
  );
};

export default HomePage;
